import { render, staticRenderFns } from "./Ueberpruefung.vue?vue&type=template&id=1722a89b&"
import script from "./Ueberpruefung.vue?vue&type=script&lang=js&"
export * from "./Ueberpruefung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports